import { writable, get } from 'svelte/store';
import { spring } from 'svelte/motion';
export const coords = spring({ x: 50, y: 50 }, {
    stiffness: 0.001,
    damping: 0.50
});
export let opacity = writable(1);
export let scale = spring(1, {
    stiffness: 0.001,
    damping: 0.50
});
let followMouse = writable(false),
    minScale = 0.5,
    maxScale = 1.5,
    padding = 50;

function helloLara() {
    const { subscribe } = writable(0);

    return {
        subscribe,
        setCoords: (newCoords) => {
            if( newCoords.x ) {
                newCoords.x = Math.max( padding, Math.min ( window.innerWidth - padding, newCoords.x ));
            }
            if( newCoords.y ) {
                newCoords.y = Math.max( padding, Math.min ( window.innerHeight - padding, newCoords.y ));
            }
            coords.set(newCoords);
        },
        setOpacity: (newOpacity) => {
            opacity.set(newOpacity);
        },
        followMouse: (bool) => {
            followMouse.set(bool == true);
        }
    }
}

export const laraStore = helloLara();

function updateCoords(e) {
    scale.set( (maxScale - minScale) / 100 * ( e.clientY / window.innerHeight * 100) + minScale );
    laraStore.setCoords({ x: e.clientX, y: e.clientY });
}
followMouse.subscribe(() => {
    if (get(followMouse)) {
        window.addEventListener('mousemove', updateCoords);
    } else {
        window.removeEventListener('mousemove', updateCoords);
    }
});